<template>
  <div>
    <div v-outside-click="hide" class="styles" :class="{ 'styles-expanded': showMore }">
      <div class="styles-list">
        <div
          data-test-id="'styles-toggle-btn'"
          class="styles-styleBtn"
          :class="{ 'icon-chevron-down': !showMore, 'icon-chevron-up': showMore }"
          @click="showMore = !showMore"
        >
          {{ $t("contextMenu.styles") }}
        </div>
        <style-item
          v-for="(style, index) in stylesToDisplay"
          :key="style.id"
          :style-item="style"
          :index="index"
          :class-name="{ 'style-item-active': index == activeIndex }"
          :data-test-id="`style-item-${style.name}`"
        />
        <span
          v-if="showMore"
          data-test-id="styles-add-btn"
          class="styles-addBtn styles-btns icon-plus-circle-outline"
          @click="addStyle"
        ></span>
      </div>
      <div v-if="showMore" class="styles-btns">
        <span
          data-test-id="styles-save-btn"
          class="styles-saveBtn"
          :class="{ 'styles-saveBtn_disabled': !editableStyleId }"
          @click="saveChanges"
          >{{ $t("actions.save") }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import DesignerMixin from "../../DesignerMixin";
import StyleItem from "./StyleItem.vue";
import { HotkeyScopes } from "../../../../utils/constants";

export default {
  components: {
    StyleItem,
  },
  mixins: [DesignerMixin],
  data() {
    return {
      showMore: false,
      activeIndex: -1,
    };
  },
  computed: {
    styles() {
      return this.$store.state.preferences.allPreferences.styles;
    },
    stylesToDisplay() {
      return this.showMore ? this.styles : this.styles.slice(0, 5);
    },
    editableStyleId() {
      return this.$store.state.preferences.editableStyleId;
    },
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.CustomStyles);
    hotkeys("right, left, up, down, enter, escape, space", HotkeyScopes.CustomStyles, (event, handler) => {
      event.preventDefault();
      switch (handler.key) {
        case "left":
          this.moveLeft();
          break;
        case "right":
          this.moveRight();
          break;
        case "up":
          this.moveUp();
          break;
        case "down":
          this.moveDown();
          break;
        case "escape":
          this.hide();
          break;
        case "space":
          this.showMore = !this.showMore;
          break;
        case "enter":
          this.selectStyle(this.styles[this.activeIndex]);
          break;
      }
    });
  },
  beforeUnmount() {
    hotkeys.unbind("right, left, up, down, enter, escape, space", HotkeyScopes.CustomStyles);
    this.$store.dispatch("setScope", HotkeyScopes.ProcessDesigner);
  },
  methods: {
    addStyle() {
      this.$store.dispatch("preferences/setEditableStyleId", null);

      const id = this.styles.length + 1;
      const key = "styles";
      const value = [
        ...this.styles,
        {
          id,
          name: id,
        },
      ];
      this.$store.dispatch("preferences/update", { key, value });
      this.$store.dispatch("smartSearch/loadStyles", null, { root: true });
    },
    saveChanges() {
      this.$store.dispatch("preferences/setEditableStyleId", null);
    },
    hide() {
      this.$store.dispatch("preferences/toggleShowCutomStyles", false);
    },
    moveRight() {
      if (this.activeIndex < this.styles.length - 1) this.activeIndex += 1;
    },
    moveLeft() {
      if (this.activeIndex > 0) this.activeIndex -= 1;
    },
    moveUp() {
      if (this.activeIndex === -1) this.activeIndex = this.styles.length - 1;
      else if (this.activeIndex >= 7) this.activeIndex -= 7;
    },
    moveDown() {
      if (this.activeIndex === -1) this.activeIndex += 1;
      else if (this.activeIndex < this.styles.length - 1) this.activeIndex += 7;
    },
    selectStyle(styleItem) {
      this.$store.dispatch("rangeStyle/updateRangeStyle", { data: styleItem });
      // this.$store.dispatch("preferences/toggleShowCutomStyles", false);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.styles {
  position: absolute;
  top: 2.5rem;
  left: -10rem;
  border-radius: 8px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border: 0.5px solid lightgray;
  background-color: @kk-color-background;
  z-index: 220;

  &-addBtn,
  &-saveBtn {
    justify-content: center;
    border-radius: @kk-border-radius;
    border: 0.5px dashed lightgray;
    cursor: pointer;
    &:hover {
      background-color: @kk-color-lighter-gray;
    }
  }

  &-saveBtn,
  &-styleBtn {
    height: 1.7rem;
    width: fit-content;
    background-color: white;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &_disabled {
      cursor: not-allowed;
      background-color: #cccccc;
      color: #888888;
      &:hover {
        background-color: #cccccc;
      }
    }
  }
  &-list {
    display: grid;
    grid-template-columns: repeat(7, 2rem);
    grid-gap: 10px;
    padding: 0.7rem;
    max-height: 10rem;
    overflow: auto;
    grid-auto-rows: 2rem;
  }
  &-styleBtn {
    grid-column: 1 / span 2; /* Span 2 columns for the button's width */
    border-radius: @kk-border-radius;
  }

  &-btns {
    padding: 0.3rem;
    display: flex;
    align-items: center;
    border-top: 1px solid lightgray;
  }
}
</style>
